export default {
  withBorderBottom: {
    borderBottom: [1, 'solid', '#eee'],
  },

  withGutterBottom: {
    marginBottom: 24,
  },
};
